import React, { memo, useState, useEffect } from 'react'
import { article } from '@Api'
import cx from 'classnames'
import { IResponse } from '@Lib/request'
import styles from './hotArticle.module.less'

interface IArticle {
  id: number;
  thumb: string;
  type: string;
  link: string;
  title: string;
}

interface IProps {
  title: string;
  fetchParams: {};
  fetchData: (params: any) => Promise<IResponse<any>>;
  style?: {};
}

const HotArticle: React.FC<IProps> = ({title, fetchData, fetchParams, style}) => {
  const [data, setData] = useState<IArticle[]>([]);

  const fetch = async() => {
    const res = await fetchData(fetchParams);

    if (res && res.status === 12000) {
      setData(res.data.list);
    }
  }

  useEffect(() => {
    fetch()
  }, [])

  return (
    <div className={styles['hot-article']} style={style}>
      {
        Array.isArray(data) &&
        data.length > 2 && (
          <>
            <h3>{title}</h3>
            {
              data.map((item, inx) => (
                <div className={cx(styles['item'], { [styles['top']]: inx < 3 })} key={inx}>
                  <a href={item.link}>
                    <span className={styles['item-icon']}>{inx + 1}</span>
                    <h4>{item.title}</h4>
                  </a>
                </div>
              ))
            }
          </>
        )
      }
    </div>
  )
}

export default memo(HotArticle);